import { CardType, Maybe, Operation } from '../../../__generated__/globalTypes'

import getOrCreateEditableCardForRecipientString from '../GetOrCreateEditableCardForRecipient.graphql'

export type GetOrCreateEditableCardForRecipientData = {
  getOrCreateEditableCardForRecipient: {
    card: {
      id: string
      type: CardType
      isHorizontal: boolean
      frontPreviewUrl: string
      insidePreviewUrl: Maybe<string>
      flapPreviewUrl: Maybe<string>
      backPreviewUrl: string
      panels: {
        width: number
        height: number
      }[]
    }
  }
}

export type GetOrCreateEditableCardForRecipientVariables = {
  recipientId: string
  productionId?: Maybe<string>
}

export type GetOrCreateEditableCardForRecipient = Operation<
  GetOrCreateEditableCardForRecipientData,
  GetOrCreateEditableCardForRecipientVariables
>

export const GetOrCreateEditableCardForRecipient = ({
  recipientId,
  productionId,
}: GetOrCreateEditableCardForRecipientVariables): GetOrCreateEditableCardForRecipient => ({
  query: getOrCreateEditableCardForRecipientString,
  variables: {
    recipientId,
    productionId,
  },
})
